import {useTranslation} from 'react-i18next'
import {SGSST_GROUP_BY_KEY} from '@/lib/constants'
import {cn} from '@/lib/utils'

export const CYCLE_ORDER = ['PLANEAR', 'HACER', 'VERIFICAR', 'ACTUAR']

export type GroupBy = 'numeral' | 'phase'

export function readGroupBy(): GroupBy {
  return localStorage.getItem(SGSST_GROUP_BY_KEY) === 'phase' ? 'phase' : 'numeral'
}

export function GroupByToggle({value, onChange}: {value: GroupBy; onChange: (next: GroupBy) => void}) {
  const {t} = useTranslation()
  return (
    <div className="inline-flex items-center gap-1" data-testid="sgsst-group-by">
      <span className="font-mono text-[10px] tracking-wider text-muted-foreground uppercase">
        {t('sgsst.groupBy.label')}
      </span>
      <div
        className="inline-flex gap-0.5 rounded-lg bg-secondary p-0.5"
        role="group"
        aria-label={t('sgsst.groupBy.label')}>
        {(['numeral', 'phase'] as const).map((mode) => (
          <button
            key={mode}
            type="button"
            aria-pressed={value === mode}
            data-testid={`group-by-${mode}`}
            onClick={() => onChange(mode)}
            className={cn(
              'rounded-md px-2.5 py-1 font-mono text-[11px] tracking-wide whitespace-nowrap transition-colors',
              value === mode
                ? 'bg-card font-semibold text-primary shadow-xs'
                : 'text-muted-foreground hover:text-foreground'
            )}>
            {t(`sgsst.groupBy.${mode}`)}
          </button>
        ))}
      </div>
    </div>
  )
}
